import { Link } from './components/Link';
import {
  STRUCTURED_CONTENT_COMPONENTS_BASE,
  STRUCTURED_CONTENT_COMPONENTS_LEARN_CONTENT_OVERRIDES,
} from './config';
import { createStructuredContentRenderer } from './createRenderer';
import { renderStructuredContent, setRenderer } from './renderContext';
import type { StructuredContent } from './types';

const APP_STRUCTURED_CONTENT_COMPONENTS = {
  ...STRUCTURED_CONTENT_COMPONENTS_BASE,
  Link,
};

const { renderDoc } = createStructuredContentRenderer(
  APP_STRUCTURED_CONTENT_COMPONENTS,
  STRUCTURED_CONTENT_COMPONENTS_LEARN_CONTENT_OVERRIDES,
);

setRenderer(renderDoc);

export function StructuredContentRenderer({
  doc,
  useLearnContentOverrides = false,
}: {
  doc: StructuredContent;
  useLearnContentOverrides?: boolean;
}) {
  return renderStructuredContent(doc, useLearnContentOverrides);
}
